import {makeStyles} from '@material-ui/core';
import {borderColor} from '@material-ui/system';

const markdownFormatting = {
    marginBottom: '12px',
};

const markdownFormattingExtended = {
    ...markdownFormatting,
    '&:last-child': {
        marginBottom: '0',
    },
};

export const useStyles = makeStyles((useResume?: boolean) => ({
    // Main content card
    contentCard: {
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        padding: useResume ? '8px 32px 32px 32px' : '32px',
        marginTop: '24px',
        '@media (max-width: 768px)': {
            padding: '16px',
            marginTop: '16px',
        },
    },

    queryInput: {
        marginBottom: '40px',
        backgroundColor: '#E8EDEC',
        '& .Mui-disabled': {
            color: '#8BA4A1',
            backgroundColor: '#ffffff',
        },
    },

    assistStartButton: {
        backgroundColor: '#456D69',
        color: 'white',
        border: 'none',
        borderRadius: '100px',
        padding: '12px 24px',
        fontSize: '14px',
        fontWeight: 500,
        fontFamily: 'FredokaRegular',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#456D69',
        },
        marginTop: '32px',
        letterSpacing: '1.5px',
        lineHeight: '1.5',
    },

    helpMeButton: {
        backgroundColor: 'white',
        color: '#456D69',
        border: '1px solid #456D69',
        borderRadius: '100px',
        width: '100%',
        padding: '12px 24px',
        fontSize: '14px',
        fontWeight: 500,
        fontFamily: 'FredokaRegular',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#f8f9ff',
        },
        '&:disabled': {
            border: '1px solid #e0e0e0',
        },
        marginBottom: '32px',
        letterSpacing: '1.5px',
        lineHeight: '1.5',
    },

    resetButton: {
        color: '#456D69',
    },

    sectionTitle: {
        fontSize: '24px',
        fontWeight: 700,
        color: '#456D69',
        marginBottom: '24px',
        fontFamily: 'Lora',
    },

    sectionDescriptionInactive: {
        fontSize: '18px',
        color: '#456D69',
        maxWidth: '400px',
        lineHeight: '1.5',
        fontFamily: 'FredokaRegular',
        opacity: 0.5,
    },

    sectionDescriptionActive: {
        fontSize: '18px',
        color: '#456D69',
        maxWidth: '400px',
        lineHeight: '1.5',
        fontFamily: 'FredokaRegular',
    },

    initialResponse: {
        fontSize: '18px',
        color: '#456D69',
        maxWidth: '400px',
        lineHeight: '1.2',
        fontFamily: 'FredokaRegular',
    },

    chatHistory: {
        fontSize: '16px',
        color: '#456D69',
        maxWidth: '400px',
        lineHeight: '1.5',
        fontFamily: 'FredokaRegular',
    },

    thumbsIcon: {
        fontSize: '16px',
        cursor: 'pointer',
        color: '#456D69',
    },

    chatContainer: {
        maxHeight: '350px',
        overflowY: 'scroll',
        marginBottom: '24px',
    },

    prePromptContainer: {
        maxHeight: '450px',
        overflow: 'auto',
    },

    userMessageBubble: {
        backgroundColor: '#e3f2fd',
        borderRadius: '15px',
        padding: '10px 15px',
        margin: '5px 0',
        maxWidth: '90%',
        marginLeft: 'auto',
        position: 'relative',
        textAlign: 'right',
    },

    aiMessageBubble: {
        backgroundColor: '#f5f5f5',
        borderRadius: '15px',
        padding: '10px 15px 30px 15px',
        margin: '5px 0',
        maxWidth: '90%',
        position: 'relative',
        textAlign: 'left',
    },

    initialResponseFeedbackContainer: {display: 'flex', justifyContent: 'flex-end', marginTop: '18px'},

    feedbackContainer: {
        position: 'absolute',
        bottom: '5px',
        right: '10px',
        display: 'flex',
        gap: '8px',
    },
    markdownFormatting,
    markdownFormattingExtended,
    markdownFormattingExtendedH3: {
        ...markdownFormattingExtended,
        fontSize: '20px',
        fontWeight: 700,
    },
}));
